import React from 'react';

import AppearingElement from "../Helper/AppearingElement";
import '../Footer/footer.css';

import girl from '../images/girl_laptop.png';
import ziplyneLogo from '../images/ziplyne-logo.png';
import CTAButton from "../Helper/CTAButton";

function Footer() {
    return (
        <footer className="main-footer">
            <div className="main-footer-container">
                <div className="main-footer-girl-container"><img src={girl} alt="girl" width="10%" className="main-footer-girl" /></div>
                <div className="main-footer-content">
                    <h4>Ziplyne: Navigating Your Digital Transformation Journey</h4>
                    <AppearingElement>
                        <CTAButton className="ziplyne-button--gradient" size="small" variant="contained">
                            Schedule a Demo
                      </CTAButton>
                    </AppearingElement>
                </div>

                <a href="https://ziplyne.com/" className="main-footer__logo">
                    <AppearingElement threshold={'0.1'}>
                        <img alt="logo" src={ziplyneLogo} />
                    </AppearingElement>
                </a>
            </div>

        </footer>
    );
}

export default Footer;